// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._404[data-v-7cb1b029]{height:70vh}p[data-v-7cb1b029]{max-width:650px}", ""]);
// Exports
module.exports = exports;
